import React from "react";
import { Col } from 'react-bootstrap';
import AntibodyAnalysis from "./AntibodyAnalysis";
import ResultReportAnalysis from "./ResultReportAnalysis";
import SequenceVariationDiscover from "./SequenceVariationDiscover";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import {FaInfoCircle, FaRegPlusSquare, FaTrash, FaPencilAlt} from "react-icons/fa";
import {makeStyles, withStyles} from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import Tooltip from "@material-ui/core/Tooltip";
import DocManagerLink from "../../FullDocManager/DocManagerLink";
import Switch from "@mui/material/Switch";
import GQPopup from "../../../shared/components/GQPopups/GQPopup";
import { Height } from "@material-ui/icons";
import HoverPopout from "../HoverPopout";

const toolTipStyles = {
    tooltip: {
        width: "auto",
        //height: "40px",
        fontSize: '12px',
        textAlign: 'justify',
        padding: "8px 14px 8px 14px",
        boxShadow: "0px 1px 7px #888",
        backgroundColor: '#777',
        color: '#FFF'
    }
};
const CustomTooltip = withStyles(toolTipStyles)(Tooltip);
const Accordion = withStyles({
    root: {
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
    root: {
        minHeight: 3,
        width: '102%',
        margin: 0,
        '&$expanded': {
            minHeight: 3,
            margin: 0,
        },
    },
    content: {
        margin: '0',
        padding: '0',
        '&$expanded': {
            margin: '0',
        },
    },
    expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: '0 0 0 5px',
        margin: '0',
        display: 'block'
    },
}))(MuiAccordionDetails);

const CmAccordionDetails = withStyles((theme) => ({
    root: {
        padding: '0 0 0 5px',
        margin: '0',
        display: 'inline-block'
    },
}))(MuiAccordionDetails);

function GQPowerTools(props){

    const { 
        applyFilterForJava, 
        userdir, 
        AB, 
        VM,
        CM,
        toggle,
        //AbReportNames, 
        saveResultState, 
        loadResultsFromBackend, 
        abFilters, 
        apiKey, 
        vmIds,  
        //widgetState,
        filter, 
        fieldConfig,
        setLvaFilterCheckbox,
        removeLvaFilterFromList,
        sideMenuDetail,
        lvaLoadingReady,
        reportId,
        reportFilters,
        editable,
        updateKWs,
        ftWindowsToOpen,
        setFtWindowsToOpen,
        cmColorLevel,
        refreshCmColorLevel,
        refreshCmAlign,
        highlightHits,
        data,
        querySeqIdsCount,
        toggleSideMenuDetail,
        cmMap,
        cmColorMap,
        cmCodes,
        setQueryCmCodeCheckbox,
        setCmFilterCheckbox,
        openCmCodeModal,
        deleteCmFilter,
    } = props;

    const useStyles = makeStyles((theme) => ({}));
    const classes = useStyles();
    const hasQuerySequence = Number(querySeqIdsCount) > 0;

    const openDeleteQspDialog = (idx) => {
        setSelectedCmFilterIdx(idx);
        setOpenDelUI(true);
    }

    const closeDeleteQspDialog = () => {
        setSelectedCmFilterIdx(-1);
        setOpenDelUI(false);
    }

    const delQSP = () => {
        if (selectedCmFilterIdx >= 0) {
            deleteCmFilter(selectedCmFilterIdx);
        }
        closeDeleteQspDialog();
    }
    
    const [openDelUI, setOpenDelUI] = React.useState(false);
    const [selectedCmFilterIdx, setSelectedCmFilterIdx] = React.useState(-1);
    

    //useEffect( async() => {
        // TODO, refresh the apiKey? props.apiKey
    //}, []);

	return (
		<div>
            <DocManagerLink
                ftWindowsToOpen={ftWindowsToOpen}
                setFtWindowsToOpen ={(value)=>{setFtWindowsToOpen(value)}}
                updateKWs = { updateKWs }
            ></DocManagerLink>
            
		    <ResultReportAnalysis reportFilters={reportFilters} apiKey={apiKey}
		                          sideMenuDetail={sideMenuDetail} userDir={userdir}></ResultReportAnalysis>
            
            
            {AB === true &&
                <AntibodyAnalysis
                    //AbReportNames={AbReportNames}
                    abFilters={abFilters}
                    apiKey={apiKey}
                ></AntibodyAnalysis>
            }
            {(VM === true || AB === true) &&
                <SequenceVariationDiscover
                    applyFilterForJava={applyFilterForJava}
                    apiKey={apiKey}
                    userDir={userdir}
                    vmIds={vmIds}
                    saveResultState={saveResultState}
                    loadResultsFromBackend={loadResultsFromBackend}
                    filter={filter}
                    fieldConfig={fieldConfig}
                    setLvaFilterCheckbox={setLvaFilterCheckbox}
                    removeLvaFilterFromList={removeLvaFilterFromList}
                    menuDetail={sideMenuDetail}
                    lvaLoadingReady={lvaLoadingReady}
                    reportId={reportId}
                    editable={editable}
                ></SequenceVariationDiscover>
            }
            {VM !== true &&
                <Accordion square expanded={false}>
                    <AccordionSummary aria-controls="panel-lva" className="subMenuHeading p-0">
                        <p className="subMenuHeading m-0">
                            <span style={{color: '#CCC'}}><ArrowRightIcon/>Sequence Variation Discovery&nbsp;</span>
                            <span className="glyphicon glyphicon-info-sign"></span>
                        </p>
                        <CustomTooltip arrow title={"The Sequence Variation Discovery Power Tools suite simplifies and streamlines the complex task of variant IP search and analysis. To learn more, email GQ-Support@aptean.com."} placement="top">
                            <span><FaInfoCircle/>&nbsp;&nbsp;</span>
                        </CustomTooltip>
                    </AccordionSummary>
                </Accordion>
            }
            {CM === true &&
                <Accordion square expanded={sideMenuDetail['cm-discovery']} onChange={() => toggleSideMenuDetail('cm-discovery')}>
                    <AccordionSummary aria-controls="panel-cm" className="subMenuHeading p-0">
                        <p className="subMenuHeading m-0">
                            {sideMenuDetail['cm-discovery'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                            {!sideMenuDetail['cm-discovery'] && <ArrowRightIcon className={classes.arrowIcon} />}
                            <span className="mt-4">Chemical Mod. Discovery&nbsp;</span>
                        </p>
                    </AccordionSummary>
                    <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                        <Col md="12" sm='12' xs='12' className={classes.row1}>
                            {hasQuerySequence &&
                                <Accordion square expanded={sideMenuDetail['cm-qsp']} onChange={() => toggleSideMenuDetail('cm-qsp')} style={toggle? {backgroundColor: '', paddingBottom: '6px'}:{backgroundColor: '#292929', paddingBottom: '6px'}}>
                                    <AccordionSummary aria-controls="panel-cm" className="p-0" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                        <p className="m-0">
                                            {sideMenuDetail['cm-qsp'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                            {!sideMenuDetail['cm-qsp'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                            <span className={classes.arrowIconTitle}>Query Sequence Patterns</span>
                                        </p>
                                    </AccordionSummary>
                                    <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                        <Col md="12" sm='12' xs='12' style={{paddingLeft: '5px'}}>
                                            <Accordion square expanded={true}>
                                                <AccordionSummary aria-controls='panel-content-samcustomfilter' id='paneld-header-samcustomfilter' className="subMenuHeading p-0">
                                                    <p className="subMenuHeading m-0" style={{paddingLeft: '5px'}} onClick={()=>{openCmCodeModal()}}> 
                                                        {/* up one Ricky onClick={() => {if (editable === true) {startFilteringWidget(filter, '', '');}}}> */}
                                                        <FaRegPlusSquare style={{marginRight: '5px', verticalAlign: 'middle'}} className="fa fa-plus-square"></FaRegPlusSquare>
                                                        <span>Create New Filter</span>
                                                    </p>
                                                </AccordionSummary>
                                            </Accordion>
                                            {/* <Accordion square expanded={sideMenuDetail['sampleprefamember']}
                                                       onChange={() => {toggleSideMenuDetail('sampleprefamember')}}>
                                                <AccordionSummary aria-controls='panel-content-samcustomfilter' id='paneld-header-samcustomfilter' className="subMenuHeading p-0">
                                                    <p className="subMenuHeading m-0">
                                                        {sideMenuDetail['sampleprefamember'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                                        {!sideMenuDetail['sampleprefamember'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                                        <span className="mt-4">Sample Filters</span>
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                                    <p>No sample filters</p>
                                                </AccordionDetails>
                                            </Accordion>  */}
                                            <Accordion square expanded={sideMenuDetail['cm-mycustomfilter']} onChange={() => {toggleSideMenuDetail('cm-mycustomfilter')}} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                                <AccordionSummary aria-controls='panel-content-cm-mycustomfilter' id='paneld-header-cm-mycustomfilter' className="subMenuHeading p-0" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                                    <p className="subMenuHeading m-0">
                                                        {sideMenuDetail['cm-mycustomfilter'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                                        {!sideMenuDetail['cm-mycustomfilter'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                                        <span className="mt-4">My Filters</span>
                                                    </p>
                                                </AccordionSummary>
                                                <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                                    {Array.isArray(filter.state?.cmFilters) && filter.state.cmFilters.length > 0 &&
                                                        filter.state.cmFilters.map((cmFilter, idx) => {
                                                            return (
                                                                <Col key={'cmFilter_' + idx} style={{paddingLeft: '10px'}}>
                                                                    <HoverPopout>
                                                                    <div className="custom-filter-no-wrap">
                                                                        <input
                                                                            type="checkbox"
                                                                            id={'cb_cmFilter_' + idx}
                                                                            style={{verticalAlign: 'middle'}}
                                                                            checked={Array.isArray(filter.state?.cmFilterCheckboxes) ? (filter.state.cmFilterCheckboxes[idx] !== false) : true}
                                                                            onChange={(e)=> {setCmFilterCheckbox(filter, idx); e.stopPropagation();}}
                                                                        />
                                                                        <label htmlFor={'cb_cmFilter_' + idx} style={{marginBottom: '0px'}}>
                                                                            {cmFilter?.filterName || 'Untitled pattern'}
                                                                        </label>
                                                                        <HoverPopout.Actions>
                                                                            {editable &&
                                                                                <div style={{display: 'inline-flex', alignItems: 'center'}}>
                                                                                    &nbsp;&nbsp;<Tooltip title="Edit" placement="top" arrow><a href="#" onClick={(e) => {e.stopPropagation();e.preventDefault();openCmCodeModal(cmFilter, idx);}}><FaPencilAlt size={13} style={{color: "#337ab7"}} /></a></Tooltip>
                                                                                    &nbsp;<Tooltip title="Delete" placement="top" arrow><a href="#" onClick={(e) => {e.stopPropagation();e.preventDefault();openDeleteQspDialog(idx);}}><FaTrash size={13} style={{color: "#337ab7"}} /></a></Tooltip>
                                                                                </div>
                                                                            }
                                                                        </HoverPopout.Actions>
                                                                    </div>
                                                                    </HoverPopout>
                                                                </Col>
                                                            );
                                                        })
                                                    }
                                                </AccordionDetails>
                                            </Accordion>
                                        </Col>
                                    </AccordionDetails>
                                </Accordion>
                            }
                            {!hasQuerySequence &&
                                <Accordion square expanded={false} style={toggle? {backgroundColor: '', paddingBottom: '6px'}:{backgroundColor: '#292929', paddingBottom: '6px'}}>
                                    <AccordionSummary aria-controls="panel-cm" className="p-0" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                        <p className="m-0">
                                            <span style={{color: '#CCC'}}>
                                                <ArrowRightIcon className={classes.arrowIcon} />
                                                <span className={classes.arrowIconTitle}>Query Sequence Patterns</span>
                                            </span>
                                        </p>
                                        <CustomTooltip arrow title={"Query Sequence Patterns require a Discover result with at least one query sequence."} placement="top">
                                            <span style={{color: '#CCC', position: 'relative', top: '-1px', left: '4px'}}><FaInfoCircle/>&nbsp;&nbsp;</span>
                                        </CustomTooltip>
                                    </AccordionSummary>
                                </Accordion>
                            }
                            <Accordion square expanded={sideMenuDetail['cm-color']} onChange={() => toggleSideMenuDetail('cm-color')} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                <AccordionSummary aria-controls="panelcmcolor-content" id="panelcmcolor-header" className="p-0" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                    <p className="m-0">
                                        {sideMenuDetail['cm-color'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                        {!sideMenuDetail['cm-color'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                        <span className={classes.arrowIconTitle}>Color Mode</span>
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                    
                                    <Col md="12" sm='12' xs='12' className={classes.row1}>
                                        <input id="cmLevel1" type="radio" value="1" name="colorRadioGroup" style={{verticalAlign: 'middle'}}
                                               checked={cmColorLevel === 1} onChange={() => refreshCmColorLevel(1, data, filter, fieldConfig, cmMap, cmColorMap)}/>
                                        <label htmlFor='cmLevel1'>&nbsp;Classification Level 1</label>
                                    </Col>
                                    <Col md="12" sm='12' xs='12' className={classes.row1}>
                                        <input id="cmLevel2" type="radio" value="2" name="colorRadioGroup" style={{verticalAlign: 'middle'}}
                                               checked={cmColorLevel === 2} onChange={() => refreshCmColorLevel(2, data, filter, fieldConfig, cmMap, cmColorMap)}/>
                                        <label htmlFor='cmLevel2'>&nbsp;Classification Level 2</label>
                                    </Col>
                                    <Col md="12" sm='12' xs='12' className={classes.row1}>
                                        <input id="cmLevel3" type="radio" value="3" name="colorRadioGroup" style={{verticalAlign: 'middle'}}
                                               checked={cmColorLevel === 3} onChange={() => refreshCmColorLevel(3, data, filter, fieldConfig, cmMap, cmColorMap)}/>
                                        <label htmlFor='cmLevel3'>&nbsp;Classification Level 3</label>
                                    </Col>
                                    <Col md="12" sm='12' xs='12' className={classes.row1}>
                                        <input id="cmLevel4" type="radio" value="4" name="colorRadioGroup" style={{verticalAlign: 'middle'}}
                                               checked={cmColorLevel === 4} onChange={() => refreshCmColorLevel(4, data, filter, fieldConfig, cmMap, cmColorMap)}/>
                                        <label htmlFor='cmLevel4'>&nbsp;Modification Level</label>
                                    </Col>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion square expanded={false} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                <AccordionSummary aria-controls="panelcmhits-content" id="panelcmhits-header" className="p-0" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                    <p className="m-0">
                                        <ArrowRightIcon className={classes.arrowIcon} />
                                        <span className={classes.arrowIconTitle}>Highlight Hits Only</span>
                                        <Switch
                                            checked={highlightHits}
                                            onChange={() => refreshCmAlign(!highlightHits, data, filter, fieldConfig)}
                                            color="primary"
                                            inputProps={{ 'aria-label': 'toggle switch' }}
                                        />
                                    </p>
                                </AccordionSummary>
                            </Accordion>
                            <Accordion square expanded={sideMenuDetail['cm-filter']} onChange={() => toggleSideMenuDetail('cm-filter')} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                <AccordionSummary aria-controls="panelcmfilter-content" id="panelcmfilter-header" className="p-0" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                    <p className="m-0">
                                        {sideMenuDetail['cm-filter'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                        {!sideMenuDetail['cm-filter'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                        <span className={classes.arrowIconTitle}>Chemical Modification Filter</span>
                                    </p>
                                </AccordionSummary>
                                <CmAccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                    {Object.keys(cmCodes).map(
                                        (item, index) => (
                                            <Accordion square expanded={sideMenuDetail['cm-' + cmCodes[item].label]} onChange={() => {toggleSideMenuDetail('cm-' + cmCodes[item].label)}} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                                <AccordionSummary aria-controls="panelcm-content" id="panelcm-header" className="subMenuHeading p-0">
                                                    <p className="subMenuHeading m-0">
                                                        {sideMenuDetail['cm-' + cmCodes[item].label] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                                        {!sideMenuDetail['cm-' + cmCodes[item].label] && <ArrowRightIcon className={classes.arrowIcon} />}
                                                        <input type="checkbox" id={'cm_code_' + index} key={'cm_code_' + index}
                                                               style={{verticalAlign: 'middle'}}
                                                               checked={(filter.state.queryCmCodes && filter.state.queryCmCodes[cmCodes[item].code]) || false}
                                                               onClick={(e)=> {setQueryCmCodeCheckbox(filter, cmCodes, cmCodes[item].code);e.stopPropagation();}} />
                                                        <div style={{display: 'inline-block'}}>
                                                            <label htmlFor={'cm_code_' + index} key={'cm_label_' + index}>
                                                                &nbsp;
                                                                {cmCodes[item].label}
                                                            </label>
                                                        </div>
                                                    </p>
                                                </AccordionSummary>
                                                <CmAccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                                    {Object.keys(cmCodes[item].codes).map(
                                                        (code, subInx) =>
                                                            <Col key={'cmcode_' + index + '_' + subInx} md="12" sm='12' xs='12'>
                                                                <Accordion square expanded={sideMenuDetail['cm-' + cmCodes[item].label + '/' + cmCodes[item].codes[code].label]}
                                                                           onChange={() => {toggleSideMenuDetail('cm-' + cmCodes[item].label + '/' + cmCodes[item].codes[code].label)}}
                                                                           style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                                                    <AccordionSummary aria-controls="panelcmlevel2-content" id="panelcmlevel2-header" className="subMenuHeading p-0">
                                                                        <p className="subMenuHeading m-0">
                                                                            {sideMenuDetail['cm-' + cmCodes[item].label + '/' + cmCodes[item].codes[code].label] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                                                            {!sideMenuDetail['cm-' + cmCodes[item].label + '/' + cmCodes[item].codes[code].label] && <ArrowRightIcon className={classes.arrowIcon} />}

                                                                            <input type="checkbox" id={'cm_code_' + index + '_' + subInx} key={'cm_code_' + index + '_' + subInx}
                                                                                   style={{verticalAlign: 'middle'}}
                                                                                   checked={(filter.state.queryCmCodes && filter.state.queryCmCodes[cmCodes[item].codes[code].code]) || false}
                                                                                   onClick={(e)=> {setQueryCmCodeCheckbox(filter, cmCodes, cmCodes[item].codes[code].code);e.stopPropagation();}} />
                                                                            <div style={{display: 'inline-block'}}>
                                                                                <label htmlFor={'cm_code_' + index + '_' + subInx} key={'cm_label_' + index + '_' + subInx}>
                                                                                    &nbsp;
                                                                                    {(!cmCodes[item].codes[code].codes || Object.keys(cmCodes[item].codes[code].codes).length < 1) &&
                                                                                        <><div className={'cm-color-box highlight-' + cmCodes[item].codes[code].color}></div>&nbsp;</>}
                                                                                    {cmCodes[item].codes[code].label}
                                                                                </label>
                                                                            </div>
                                                                        </p>
                                                                    </AccordionSummary>
                                                                    {cmCodes[item].codes[code].codes && Object.keys(cmCodes[item].codes[code].codes).length > 0 &&
                                                                        <CmAccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                                                            {Object.keys(cmCodes[item].codes[code].codes).map(
                                                                            (cm, level3Idx) =>
                                                                            <Col key={'cmcode_' + index + '_' + subInx + '_' + level3Idx} md="12" sm='12' xs='12'>
                                                                                <div className={'cm-name'}>
                                                                                    &nbsp;
                                                                                    <input type="checkbox" id={'cm_code_' + index + '_' + subInx + '_' + level3Idx}
                                                                                           key={'cm_code_' + index + '_' + subInx + '_' + level3Idx}
                                                                                           style={{verticalAlign: 'middle'}}
                                                                                           checked={(filter.state.queryCmCodes && filter.state.queryCmCodes[cmCodes[item].codes[code].codes[cm].code]) || false}
                                                                                           onChange={(e)=> {setQueryCmCodeCheckbox(filter, cmCodes, cmCodes[item].codes[code].codes[cm].code)}} />
                                                                                    <div style={{display: 'inline-block'}}>
                                                                                        <label htmlFor={'cm_code_' + index + '_' + subInx + '_' + level3Idx}
                                                                                               key={'cm_label_' + index + '_' + subInx + '_' + level3Idx}>
                                                                                            &nbsp;<div className={'cm-color-box highlight-' + cmCodes[item].codes[code].codes[cm].color}></div>
                                                                                            &nbsp;{cmCodes[item].codes[code].codes[cm].label}
                                                                                        </label>
                                                                                    </div>
                                                                                </div>
                                                                            </Col>
                                                                            )}
                                                                        </CmAccordionDetails>
                                                                    }
                                                                </Accordion>
                                                            </Col>
                                                        )}
                                                </CmAccordionDetails>
                                            </Accordion>
                                        ))}
                                </CmAccordionDetails>
                            </Accordion>
                        </Col>
                    </AccordionDetails>
                </Accordion>
            }
            <GQPopup
                show={openDelUI}
                close={() => closeDeleteQspDialog()}
                innerHtml={
                    <div style={{width: '400px'}}>
                        <h4 style={{marginBottom: '12px'}}>Delete Filter</h4>
                        <p style={{marginBottom: '16px'}}>Delete this query sequence pattern?</p>
                        <div style={{display: 'flex', justifyContent: 'flex-end', gap: '8px'}}>
                            <button className="small-button cancelButtonClass" onClick={() => closeDeleteQspDialog()}>Cancel</button>
                            <button className="small-button submitButtonClass" onClick={() => delQSP()}>Delete</button>
                        </div>
                    </div>
                }
            />
        </div>
    );
}

export default GQPowerTools;
